import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import ReportRecordDataProvider from '/component/partial/reportCard/ReportRecordDataProvider';
import {paidAsRankDescLastMonth} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import ClientReportPopover from './ClientReportPopover';

export default connect(
  createStructuredSelector({
    userId,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
  }),
  null,
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    dataRenderer: ClientReportPopover,
    dataRendererProps: {...ownProps, lastPaidRank: stateProps.lastPaidRank},
  }),
)(ReportRecordDataProvider);
